<ngx-premium-trial-reminder></ngx-premium-trial-reminder>
<!-- <nb-tabset fullWidth>
  <nb-tab tabTitle="Brand"> -->
    <nb-card>
      <nb-card-header>
        <div class="title" i18n="@@CustomizeBranding">Customize Branding for Website</div>
      </nb-card-header>
      <nb-card-body>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-5 col-xxl-4">
            <!-- Current Logo -->
            <nb-card>
              <nb-card-header>
                <div i18n="@@CurrentLogo">Current Logo</div>
              </nb-card-header>

              <nb-card-body>
                <p style="font-size: 0.8rem;">
                  You can customize the main logo branding.<br />
                  Upload logo on transparent background or white background for better result.
                </p>
                <img [src]="logoSrc?.length > 0 ? logoSrc : '/assets/images/logo.png'" alt="logo branding"
                  class="w-100 mb-3 d-block" style="max-width: 400px; max-height: 200px; object-fit: contain;">
                <button nbButton class="btn-main btn-circle btn-xl" (click)="file.click()">Upload new Logo</button>
                <input type="file" #file accept="image/*" hidden (change)="onLogoChange($event)" />
              </nb-card-body>
            </nb-card>
            <!-- Color Theme -->
            <nb-card class="mb-0">
              <nb-card-header>
                <div i18n="@@ColorTheme">Color Theme</div>
              </nb-card-header>

              <nb-card-body>
                <p style="font-size: 0.8rem;">
                  You can also select a main color switch to better reflect your branding.
                </p>
                <ngx-inline-color-picker (selected)="onColorChanged($event)" [default]="color"
                  [isWaiting]="!isIframeLoaded">
                </ngx-inline-color-picker>
              </nb-card-body>
            </nb-card>
            <br><br>
          </div>
          <!-- Preview -->
          <div class="col-sm-12 col-md-6 col-lg-7 col-xxl-8">
            <nb-card class="mb-0 w-100 h-100" style="min-height: 500px;">
              <nb-card-header>
                <div i18n="@@Preview">Preview</div>
              </nb-card-header>
              <nb-card-body class="p-0">
                <div class="overflow-hidden" style="width: 100%; height: 100%; overflow: hidden;">
                  <iframe src="/patients" #iframe (load)="onIframeLoaded()" style="width: 130%; height: 130%;"></iframe>
                  <div class="iframe-blocker">
                  </div>
                </div>
              </nb-card-body>
            </nb-card>
          </div>
        </div>
      </nb-card-body>

      <nb-card-footer>
        <button i18n="@@Save" nbButton class="btn-circle btn-xl btn-main"  (click)="onSave()"
          [disabled]="isSaving || !isIframeLoaded || !changed" [nbSpinner]="isSaving">
          Save Branding
        </button>
      </nb-card-footer>
    </nb-card>
    <nb-card *ngIf="customAppEnabled">
      <nb-card-header>
        <div class="title" i18n="@@CustomizeBranding">Customize Branding for Mobile application</div>
      </nb-card-header>

      <nb-card-body>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-5 col-xxl-4">
            <nb-card>
              <nb-card-header>
                <div i18n="@@CurrentLogo">Current App Logo</div>
              </nb-card-header>

              <nb-card-body>
                <p style="font-size: 0.8rem;">
                  You can customize the main logo branding.<br />
                  Upload logo on transparent background or white background for better result.
                </p>
                <div id="preview">
                  <div class="icon android">
                      <img id="androidPreview" [src]="appLogoSrc?.length > 0 ? appLogoSrc : '/assets/images/logo.png'" alt="logo branding" alt="Android Icon Preview"/>
                  </div>
                  <div class="icon ios">
                      <img id="iosPreview" [src]="appLogoSrc?.length > 0 ? appLogoSrc : '/assets/images/logo.png'" alt="logo branding" alt="iOS Icon Preview"/>
                  </div>
              </div>
                <button nbButton class="btn-main btn-circle btn-xl" (click)="fileAppLogo.click()">Upload new Logo</button>
                <input type="file" #fileAppLogo accept="image/*" hidden (change)="onAppLogoChange($event)" />
                <div class="form-group mt-3">
                  <label for="appName" class="mr-3">App Name</label>
                  <input nbInput id="appName" type="text" placeholder="App Name" [(ngModel)]="appName" />
                </div>
              </nb-card-body>
            </nb-card>
            <nb-card class="mb-0">
              <nb-card-header>
                <div i18n="@@ColorTheme">Splash screen</div>
              </nb-card-header>

              <nb-card-body>
                <p style="font-size: 0.8rem;">
                  You can also select a main color switch to better reflect your branding.
                </p>
                <ngx-inline-color-picker [isAppColors]="true" (selected)="onSplashColorChanged($event)" [default]="splashColor">
                </ngx-inline-color-picker>
              </nb-card-body>
            </nb-card>
            <br><br>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-7 col-xxl-8">
            <nb-card class="mb-0 w-100">
              <nb-card-header>
                <div i18n="@@Preview">Preview</div>
              </nb-card-header>
              <nb-card-body class="d-flex justify-content-center align-items-center">
                <div class="iphone">
                  <div class="iphone-top">
                      <span class="camera"></span>
                      <span class="speaker"></span>
                  </div>
                  <div class="splash-screen" [style.backgroundColor]="splashColor.primary">
                      <img [src]="logoSrc?.length > 0 ? logoSrc : '/assets/images/logo.png'" alt="Logo" class="logo">
                  </div>
                  <div class="iphone-bottom"></div>
              </div>
              </nb-card-body>
            </nb-card>
          </div>
        </div>
      </nb-card-body>

      <nb-card-footer>
        <button i18n="@@Save" nbButton class="btn-circle btn-xl btn-main"  (click)="onSave()"
          [disabled]="isSaving" [nbSpinner]="isSaving">
          Save Branding
        </button>
      </nb-card-footer>
    </nb-card>
    <ng-container *ngIf="customAppEnabled || isTfAdmin">
      <app-settings [disabled]="!isTfAdmin" *ngIf="userSettings && user"  (userSettingsChange)="saveAppSettings($event)" [userSettings]="userSettings" [user]="user"></app-settings>
    </ng-container>


<!-- Image Cropper Dialog -->
<ng-template #cropperDlg let-data let-ref="dialogRef">
  <nb-card class="dlg-container mb-0" style="max-height:95vh;max-width:95vw;">
    <nb-card-header class="d-flex align-items-center title">
      <div class="title">Crop Image</div>
      <button nbButton static="basic" ghost shape="round" size="small" (click)="onCancelImageCropping(ref)"
        class="ml-auto">
        <nb-icon icon="close"></nb-icon>
      </button>
    </nb-card-header>

    <nb-card-body>
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="false"
        (imageCropped)="onImageCropped($event)" (loadImageFailed)="onLoadImageFailed($event)">
      </image-cropper>
    </nb-card-body>

    <nb-card-footer>

      <button nbButton  (click)="onUpdateLogo(ref)" class="m-1 btn-main btn-circle btn-xl" [nbSpinner]="isBusy">Confirm</button>
      <button nbButton  (click)="onCancelImageCropping(ref)" class="btn-back btn-circle btn-xl">Cancel</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<!-- Image Cropper Dialog -->
<ng-template #cropperDlgIcon let-data let-ref="dialogRef">
  <nb-card class="dlg-container mb-0" style="max-height:95vh;max-width:95vw;">
    <nb-card-header class="d-flex align-items-center title">
      <div class="title">Crop Icon Image</div>
      <button nbButton static="basic" ghost shape="round" size="small" (click)="onCancelImageIconCropping(ref)"
        class="ml-auto">
        <nb-icon icon="close"></nb-icon>
      </button>
    </nb-card-header>

    <nb-card-body>
      <image-cropper [imageChangedEvent]="appLogoChangedEvent" [maintainAspectRatio]="false"
        (imageCropped)="onImageIconCropped($event)" (loadImageFailed)="onLoadImageIconFailed($event)"
        [maintainAspectRatio]="true"
    [aspectRatio]="1 / 1"
    [resizeToWidth]="192">
      </image-cropper>
    </nb-card-body>

    <nb-card-footer>

      <button nbButton  (click)="onUpdateLogoIcon(ref)" class="m-1 btn-main btn-circle btn-xl" [nbSpinner]="isBusy">Confirm</button>
      <button nbButton  (click)="onCancelImageIconCropping(ref)" class="btn-back btn-circle btn-xl">Cancel</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
